/* Publish by EComposer at 2026-03-26 13:35:40*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j35rlqb1by"]=  window.__ectimmers["ecom-j35rlqb1by"] || {};
var s,o;let t=this.$el;if(!t)return;let e=t.querySelector("afterpay-placement.ecom-afterpay-integrate"),i=this.$el.closest(".ecom-product-form--single");if(i){let a=i.querySelector('[name="id"]');if(a&&a.dispatchEvent(new window.Event("ecomUpdate")),this.settings.show_total_price){const r=i.querySelector(".ecom-product-single__quantity-input"),l=t.querySelector(".ecom-product-single__price--sale");if(!l)return;r&&r.addEventListener("change",function(){l.innerHTML=window.EComposer.formatMoney(parseInt(l.getAttribute("data-price"))*parseInt(this.value))}),i.addEventListener("ecomVariantChange",function(c){if(c.detail.variant){const d=c.detail.variant,m=r?parseInt(r.value):1;l.setAttribute("data-price",d.price),m>1&&(l.innerHTML=window.EComposer.formatMoney(d.price*parseInt(m)))}})}}if(this.settings.enable_afterpay){let a=window.document.querySelector("#ecom-after-pay-script");if(window.afterpay_min=this.settings.lower_limit||1,a)a.dataset.analyticsEnabled=!0,a.dataset.min=(s=this.settings.lower_limit)!=null?s:1,a.dataset.max=(o=this.settings.upper_limit)!=null?o:1e3;else{let r=window.document.createElement("script");r.id="ecom-after-pay-script",r.dataset.analyticsEnabled=!0,r.dataset.min=this.settings.lower_limit||1,r.dataset.max=this.settings.upper_limit||1e3,r.src="https://js.afterpay.com/afterpay-1.x.js",window.document.head.appendChild(r)}e&&this.isLive&&window.jQuery&&window.Afterpay&&window.Afterpay.initProductPage&&window.Afterpay.initProductPage(window.jQuery)}let n=t.querySelector(".ecom-product-single__price--badges-sale");if(n&&n.dataset.haveSale=="true"){let a=n.dataset.sale,r=n.dataset.text;r=r.replace(/\{.*\}/g,a),n.innerHTML=r,n.style.display="block"}

                    });
                    
                        document.querySelectorAll('.ecom-j35rlqb1by').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j35rlqb1by', settings: {"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-60ng0cj10sq"]=  window.__ectimmers["ecom-60ng0cj10sq"] || {};
if(!this.$el)return!1;const t=this.$el,e=t.closest(".ecom-product-form--single");if(!e)return!1;if(e&&this.settings.show_total_price){const c=t.querySelector(".ecom-product-single__price--sale");let d=e.querySelector("#quantity");if(c&&d){let m=function(f){c.innerHTML=window.EComposer.formatMoney(parseInt(c.getAttribute("data-price"))*parseInt(f.value))},g=function(f){setTimeout(()=>{m(f)},100),f.addEventListener("change",function(){m(f)})};g(d),e.addEventListener("ecomQuantityType",function(){e.querySelector("#quantity"),d&&g(d)}),e.addEventListener("ecomVariantChange",function(f){if(f.detail.variant){const b=f.detail.variant,y=d?parseInt(d.value):1;c.setAttribute("data-price",b.price),y>1&&(c.innerHTML=window.EComposer.formatMoney(b.price*parseInt(y)))}})}}const i=e.querySelector('[name="id"]'),n=t.querySelector(".ecom-product-single__add-to-cart--submit"),s=t.closest("form"),o=i?parseInt(i.getAttribute("ec-variants")):0,a=this.isLive&&(o>250||s.querySelector("[data-high-variant-product]"));if(!s)return;function r(){let c=null;const d=s.dataset.product_id;let m=null;if(d?m=s.querySelector("[data-selected-variant]")||s.querySelector("[id^=product-json-"+d+"]"):m=t.querySelector("[id^=addtocart-product-json]"),!m)return;try{c=JSON.parse(m.innerHTML)}catch(f){return}let g=null;if(a?g=c:g=c.variants.find(f=>f.available)||c.variants[0],g){const f=n.querySelector(".ecom-add-to-cart-text");if(!f)return;g.available==!1?(n.setAttribute("disabled","disabled"),f.innerText=n.dataset.textOutstock,n.classList.remove("ecom-product-single__pre-order")):g.inventory_quantity<=0&&g.inventory_policy=="continue"&&g.inventory_management&&(f.innerText=n.dataset.textPreOrder,n.classList.add("ecom-product-single__pre-order"))}}if(!this.isLive)e&&(i&&!i.classList.contains("ecom-product-single__picker-default-variant")?i.dispatchEvent(new window.Event("ecomUpdate")):r());else{let c=function(d){const m=e.querySelectorAll(".ecom-required--checkbox");m.length>0&&m.forEach(function(y){let v=y.querySelectorAll("input[type=checkbox]");if(v.length==0)return;let w=!1;v.forEach(function(k){k.checked&&(w=!0)}),w?v.forEach(function(k){k.required=!1}):v.forEach(function(k){k.required=!0})});const g=e.querySelectorAll(".ecom-product-single__property-file");let f=!1,b;g.length&&g.forEach(function(y){if(y.required&&(!y.value||y.value=="")){y.parentNode.parentNode.querySelector(".ecom-product-single-form--text-error").style.display="block",f=!0,b=y;return}else f=!1}),f&&(d.preventDefault(),d.stopPropagation(),b.scrollIntoView({behavior:"smooth",block:"center",inline:"nearest"}))};if((!s.querySelector("select[name=id]")||s.querySelector("select[name=id]")&&i.classList.contains("ecom-product-single__picker-default-variant"))&&r(),!i&&n&&n.dataset.variant_id){const d=document.createElement("input");d.type="hidden",d.value=n.dataset.variant_id,t.appendChild(d)}n.addEventListener("click",c)}const l=function(c){if(!t)return;const d=t.querySelector(".ecom-product-single__add-to-cart--submit");if(!d)return;let m=parseInt(c.settings.animation_loop_time)*1e3||6e3,g=1e3;window.__ectimmers["ecom-60ng0cj10sq"]["xhzes14fn"] = setInterval(function(){d.classList.add("animated"),setTimeout(function(){d.classList.remove("animated")},g)},m)};this.settings.animation&&l(this)

                    });
                    
                        document.querySelectorAll('.ecom-60ng0cj10sq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-60ng0cj10sq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3y9o4n3gga4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3y9o4n3gga4', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ijc53uhgb4g"]=  window.__ectimmers["ecom-ijc53uhgb4g"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ijc53uhgb4g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijc53uhgb4g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6j1eldyp80n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6j1eldyp80n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4mb2u121xnc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mb2u121xnc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3p3eqi0w4tf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3p3eqi0w4tf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0knxq9corcwd"]=  window.__ectimmers["ecom-0knxq9corcwd"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=e.querySelector(".ecom-element.ecom-base-image"),o=e.closest(".core__row--columns");s&&(i(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-0knxq9corcwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0knxq9corcwd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2fuu226tggt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2fuu226tggt', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i5bye3arkvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i5bye3arkvo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-um36lp24r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-um36lp24r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nllb9ve9t7"]=  window.__ectimmers["ecom-nllb9ve9t7"] || {};
const $el = this.$el;
                const products_item = $el.querySelectorAll(
                    ".ecom-product-bundle__item"
                );
                const products_title_item = $el.querySelectorAll(".item-for-loop");
                if (products_item.leng == 0) {
                    return;
                }
                const handleVariantSelect = () => {
                    if (products_title_item) {
                        products_title_item.forEach((item, index) => {
                            let select_id = item.querySelector(
                                "select[name=ecom-product-bundle-select]"
                            );
                            let item_images = item.querySelectorAll(
                                ".ecom-product-bundle__image"
                            );

                            if (!select_id) return;
                            select_id.addEventListener("change", (e) => {
                                let selected_index =
                                    select_id.options[select_id.selectedIndex];

                                if (!selected_index) return;

                                let price =
                                    selected_index.getAttribute("data-price");
                                let compare_at_price =
                                    selected_index.getAttribute(
                                        "data-compare-price"
                                    ) || 0;
                                let image =
                                    selected_index.getAttribute("data-image");
                                let product_id = selected_index.value;

                                item.querySelector(
                                    "input[name=product_id]"
                                ).value = product_id;
                                item.querySelector(
                                    ".product-bundle__checkbox-input"
                                ).setAttribute("data-product-price", price);
                                item.querySelector(
                                    ".product-bundle__checkbox-input"
                                ).setAttribute(
                                    "data-product-compare_price",
                                    compare_at_price
                                );
                                handleTotalPrice();
                                updatePrice(price, compare_at_price, item);

                                let item_for_loop_horizontal = $el.querySelectorAll('.item-for-loop-horizontal');
                                item_images.forEach(item => item.classList.add('ecom-loading-image'));
                                if(image) {
                                    item_images.forEach(item => item.querySelector('img').setAttribute('src', image));
                                    if(item_for_loop_horizontal && item_for_loop_horizontal[index])
                                        item_for_loop_horizontal[index].querySelector('img').setAttribute('src', image)
                                }
                                item_images.forEach(item => item.querySelector('img').onload = () => {
                                    item_images.forEach(item => item.classList.remove('ecom-loading-image'));
                                })
                            });
                        });
                    }

                    function updatePrice(price, compare_at_price, el) {
                        const $price_regular = el.querySelector(
                            ".ecom-product-bundle__price--regular"
                        );
                        const $price = el.querySelector(
                            ".ecom-product-bundle__price--sale"
                        );

                        if ($price) {
                            $price.innerHTML =
                                window.EComposer.formatMoney(price);
                        }

                        if ($price_regular) {
                            $price_regular.innerHTML =
                                window.EComposer.formatMoney(compare_at_price);
                            if (
                                parseFloat(compare_at_price) > parseFloat(price)
                            ) {
                                $price_regular.style.display = "inherit";
                            } else {
                                $price_regular.style.display = "none";
                            }
                        }
                    }
                };

                const handleMainProductVariantSelect = () => {
                    if (products_title_item.length == 0) return;
                    const product_form = document.querySelector(
                        "form.ecom-product-form--single"
                    );
                    const main_select =
                        product_form.querySelector("select[name=id]");
                    const main_product_bundle =
                        products_title_item[0].querySelector(
                            "select[name=ecom-product-bundle-select]"
                        );

                    if (!main_select || !main_product_bundle) return;
                    //Main select event
                    main_select.addEventListener("change", (e) => {
                        let value = e.target.value;
                        if (value && value != main_product_bundle.value) {
                            main_product_bundle.value = value;
                            main_product_bundle.dispatchEvent(
                                new Event("change")
                            );
                        }
                    });

                    //Bundle main product selet event
                    main_product_bundle.addEventListener("change", (e) => {
                        let value = e.target.value;
                        if (value) {
                            main_select.value = value;
                            main_select.dispatchEvent(new Event("swatch"));
                        }
                    });
                };

                const handleATC = () => {
                    const $btn_atc = $el.querySelector(
                        ".ecom-product-bundle__atc-btn"
                    );
                    let items = [];

                    $btn_atc.addEventListener("click", (e) => {
                        e.preventDefault();
                        const _this = e.target;
                        $btn_atc.classList.add("ecom-loading");

                        $el.querySelectorAll("input[type=checkbox]").forEach(
                            (checkbox, index) => {
                                if (checkbox.checked) {
                                    let product_id = products_title_item[
                                        index
                                    ].querySelector(
                                        "input[name=product_id]"
                                    ).value;
                                    if (!product_id) return;

                                    let item = {
                                        id: product_id,
                                        quantity: 1,
                                    };

                                    items.push(item);
                                }
                            }
                        );

                        if (items.length > 0) {
                            fetch("/cart/add.js?sections=cart-notification-product,cart-notification-button,cart-icon-bubble,cart-drawer", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({ items }),
                            })
                                .then((response) => response.json())
                                .then((response) => {
                                    if (
                                        response.status &&
                                        response.status == 422
                                    ) {
                                        window.EComposer.showToast(
                                            response.description,
                                            "error"
                                        );
                                        $btn_atc.classList.remove(
                                            "ecom-loading"
                                        );
                                        items = [];
                                        return;
                                    }
                                    if (window.EComposer.ajaxCartSuccess)
                                        window.EComposer.ajaxCartSuccess(
                                            response
                                        );
                                    $btn_atc.classList.remove("ecom-loading");
                                    items = [];
                                })
                                .catch((error) => {
                                    console.error("Error:", error);
                                });
                        }
                    });
                };

                const handleTotalPrice = () => {
                    let total_price = 0;
                    let total_compare_price = 0;
                    const checkboxs = $el.querySelectorAll(
                        "input[type=checkbox]"
                    );

                    if (!checkboxs) return;

                    if (this.settings.layout == "horizontal") {
                        var list = $el.querySelectorAll(
                            ".ecom-product-bundle__product-list .ecom-product-bundle__item "
                        );
                        list.forEach(function (item) {
                            item.style.opacity = 0.4;
                        });
                    }

                    checkboxs.forEach((checkbox, index) => {
                        checkbox.parentElement.style.opacity = 0.4;
                        if (checkbox.checked) {
                            let price =
                                checkbox.getAttribute("data-product-price");
                            let compare_price = checkbox.getAttribute(
                                "data-product-compare_price"
                            );
                            if (price) total_price += parseFloat(price);
                            if (compare_price && compare_price != '0')
                                total_compare_price +=
                                    parseFloat(compare_price);
                            else if (price)
                                total_compare_price += parseFloat(price);

                            checkbox.parentElement.style.opacity = 1;

                            if (this.settings.layout == "horizontal") {
                                if (list && list[index])
                                    list[index].style.opacity = 1;
                            }
                        }
                    });
                    $el.querySelector(
                        ".ecom-product-bundle__price--total"
                    ).innerHTML = window.EComposer.formatMoney(total_price);
                    if(this?.settings?.show_compare_price)
                        $el.querySelector(".ecom-product-bundle__price--compare").innerHTML = total_compare_price > total_price ? window.EComposer.formatMoney(total_compare_price) : "";
                };

                const handleCheckbox = function () {
                    const checkboxs = $el.querySelectorAll(
                        "input[type=checkbox]"
                    );
                    checkboxs.forEach((checkbox) => {
                        checkbox.addEventListener("change", handleTotalPrice);
                    });
                };

                const handleAnimation = function (_this) {
                    if (!$el) return;

                    const $btn_wrapper = $el.querySelector(
                        ".ecom-product-bundle__atc-btn"
                    );
                    if (!$btn_wrapper) return;

                    let intervalTime =
                            parseInt(_this?.settings.animation_loop_time) *
                                1000 || 6000,
                        animTime = 1000;window.__ectimmers["ecom-nllb9ve9t7"]["nsduhfjdo"] = setInterval(function () {
                        $btn_wrapper.classList.add("animated");
                        setTimeout(function () {
                            $btn_wrapper.classList.remove("animated");
                        }, animTime);
                    }, intervalTime);
                };

                if (this.settings.animation) {
                    handleAnimation(this);
                }

                handleVariantSelect();
                handleMainProductVariantSelect();
                handleTotalPrice();
                handleCheckbox();
                if (!window.ECOM_LIVE) handleATC();

                    });
                    
                        document.querySelectorAll('.ecom-nllb9ve9t7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nllb9ve9t7', settings: {"layout":"vertical","show_compare_price":false,"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);};window.addEventListener("load",()=>{
                let isAdmin = false;
                if(document.querySelector("#admin-bar-iframe")){
                    isAdmin = true;
                }
                if(!isAdmin) {
                    if(window.EComposerBrand) {
                        return;
                    } else {
                        window.EComposerBrand = true;
                    }
                }
                let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 11px","width: 100%","text-align: center","opacity: 1","text-indent: 0","color: rgba(18, 18, 18, 0.75)","background: transparent","opacity: 0.8",""].join(" !important;")),b.innerHTML="Built with <a style='color: currentColor;text-decoration: none;' href=\"https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=footer_branding&utm_term=links&utm_content="+window.location.origin+"\" target=\"_blank\">EComposer</a>" + (isAdmin ? ". Contact us or upgrade to remove branding" :""),a.appendChild(b)
            });